const NotFoundPage = () => {
    return (
        <div>
            <h1>Página não encontrada</h1>
            <p>Desculpe, a página que você está procurando não existe.</p>
        </div>
    )
}

export default NotFoundPage